import Button from "@/common/components/Button"
import { PermissionData } from "@/common/types/permissions"
import { ArrowBigRight } from "lucide-react"
import { Link } from "react-router-dom"

export class EstablishmentPermissionsTransformer {
  static tableTransformer() {
    return (permissions: PermissionData[]) => {
      return permissions.map((permission) => {
        return {
          ...permission,
          actions: (
            <Link to={`/establishment-permissions/${permission.id}`}>
              <Button variant="link-white" operationKlassToCheckPermission="Admin::Establishment::Permissions::Show" className="w-full">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        }
      })
    }
  }
}
